/** Raw hardware signal: does this device's primary pointer look like touch? */
export function hasCoarsePointer() {
  return window.matchMedia('(pointer: coarse)').matches || navigator.maxTouchPoints > 0;
}

/**
 * Whether the on-screen joystick/buttons (ui/TouchControls.js) and the
 * mobile display mode (Renderer._resize's no-crop letterbox scaling) should
 * be active. Defers to the player's explicit choice (Settings — see
 * SaveManager's mobileControls) when they've made one; otherwise falls back
 * to hardware auto-detection so nothing changes for anyone who hasn't
 * touched the setting.
 */
export function isMobileModeActive(save) {
  const mode = save.mobileControls;
  if (mode === 'on') return true;
  if (mode === 'off') return false;
  return hasCoarsePointer();
}

/**
 * Best-effort ask for the platform to actually rotate the screen to
 * landscape (real Screen Orientation API, not just a CSS trick) — silently
 * does nothing where it's unsupported or rejected. Chrome/Firefox only
 * honor this from within Fullscreen; iOS Safari doesn't implement it for
 * regular web pages at all. Call right after a requestFullscreen() that
 * resolves — style.css's forced-landscape rotation (see its own comment)
 * is the actual cross-platform fallback for everyone this can't reach.
 */
export function requestLandscape() {
  screen.orientation?.lock?.('landscape').catch(() => {});
}
